// extracted by mini-css-extract-plugin
module.exports = {"titleBlock":"SuccessStep_titleBlock__imHsh","descriptionBlock":"SuccessStep_descriptionBlock___IlNr","formContainer":"SuccessStep_formContainer__r48Bb"};